module.exports = __webpack_public_path__ + "static/media/iconmonstr-gmail-rounded.98442520.svg";